import weddingPic from "../../assets/projectsPics/wedding_pic.png";


const WeddingProject = {
  title: "The Wedding Website",
  description: `A personalized wedding website designed with WordPress and Elementor. 
The site features elegant layouts, RSVP functionality, Card generator, event details, 
photo galleries, and a modern responsive design optimized for both desktop 
and mobile devices. It was crafted to serve as a digital hub for wedding guests, 
combining ease of navigation with a romantic and clean aesthetic.`,
  tech: [
    "WordPress",
    "Elementor",
    "Custom CSS",
    "Responsive Design",
    "Web Hosting & Domain Setup",
  ],
  image: weddingPic,
  live: "https://hamsarfor.life/",
  github: null,
};

export default WeddingProject;
